import { Link } from 'react-router-dom'
import useScrollReveal from '../hooks/useScrollReveal'
import './Pages.css'
import './Home.css'

const hero = {
    image: '/images/group/1.jpeg',
    mobileImage: '/images/group/13.jpg',
    imagePosition: 'center top',
}

const sections = [
    { name: 'About', path: '/about', image: '/images/group/EGC09548A.JPG', bentoClass: 'bento-about', imagePosition: 'center center' },
    { name: 'Listen', path: '/listen', image: '/images/group/DSC05339.JPG', bentoClass: 'bento-listen' },
    { name: 'Members', path: '/members', image: '/images/group/13.jpg', mobileImage: '/images/group/1.jpeg', bentoClass: 'bento-members' },
    { name: 'Schedule', path: '/schedule', image: '/images/group/EGC09477A.JPG', bentoClass: 'bento-schedule', imagePosition: 'center bottom' },
    { name: 'Photos', path: '/photos', image: '/images/group/_DSC6821.JPG', bentoClass: 'bento-photos' },
    { name: 'Contact', path: '/contact', image: '/images/group/DSC05370.JPG', bentoClass: 'bento-contact' },
]

function Home() {
    const gridRef = useScrollReveal()

    return (
        <>
            <section className="home-hero">
                    <picture>
                        <source media="(max-width: 768px)" srcSet={hero.mobileImage} />
                        <img
                            src={hero.image}
                            alt="Kazoku Quartet"
                            className="home-hero-img"
                            style={hero.imagePosition ? { objectPosition: hero.imagePosition } : undefined}
                        />
                    </picture>
                    <div className="home-hero-overlay">
                        <h1 className="home-hero-title">Kazoku Quartet</h1>
                        <p className="home-hero-subtitle">Classical Saxophone - Houston and Beyond</p>
                        <div className="home-scroll-hint" aria-hidden="true">&#8595;</div>
                    </div>
            </section>
            <div className="page">

                <div className='bento-grid reveal' ref={gridRef}>
                    {sections.map(({ name, path, image, mobileImage, bentoClass, imagePosition }) => (
                        <Link to={path} className={`bento-card ${bentoClass}`} key={name}>
                            <picture>
                                {mobileImage && <source media="(max-width: 768px)" srcSet={mobileImage} />}
                                <img
                                    src={image}
                                    alt=""
                                    className='bento-img'
                                    style={imagePosition ? { objectPosition: imagePosition } : undefined}
                                />
                            </picture>
                            <h2>{name}</h2>
                        </Link>
                    ))}
                </div>
            </div>
        </>
    );
}

export default Home;
